import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { BeforePurchaseModalProps } from './BeforePurchaseModal';

export const renderBeforePurchaseModal = ({ onClose, ...data }: BeforePurchaseModalProps) =>
    openPopupHelper({ popupName: popupNames.BEFORE_PURCHASE_MODAL, data, onClose });

export const closeBeforePurchaseModal = () => closePopupHelper(popupNames.BEFORE_PURCHASE_MODAL);
